import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/_services/generatedServices';
import { EventViewModel } from 'src/app/_models/generatedModels';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'bxl-my-conference-events',
  templateUrl: 'my-conference-events.component.html'
})
export class MyConferenceEventsComponent implements OnInit {
  initialized = false;
  conferenceId: number;
  events: EventViewModel[];
  currentPage = 0;
  pageSize = 10;
  resultCount = 0;

  constructor(private route: ActivatedRoute, private userService: UserService) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.conferenceId = +params['conferenceId'];
      this.getData();
    });
  }

  getData() {
    this.userService.getConferenceEventsPaged(this.conferenceId, this.currentPage, this.pageSize).subscribe(events => {
      this.currentPage = events.currentPage;
      this.pageSize = events.pageSize;
      this.resultCount = events.rowCount;
      this.events = events.results;
      this.initialized = true;
    });
  }

  paginate(event) {
    this.currentPage = event.page;
    this.pageSize = event.rows;
    this.getData();
  }
}
